// Utilities to make your daily work easier
import { baseConfig } from '@adornis/config/baseConfig.js';

export const isDevelopment = baseConfig.get('DEPLOYMENT')?.toLowerCase() === 'development';

export const isQA = baseConfig.get('DEPLOYMENT')?.toLowerCase() === 'qa';

export const isStaging = baseConfig.get('DEPLOYMENT')?.toLowerCase() === 'staging';

export const isProduction = baseConfig.get('DEPLOYMENT')?.toLowerCase() === 'production';

export const getEnv = baseConfig.get('DEPLOYMENT')?.toLowerCase();
